<template>
  <div v-if="showTopSettingsWrapper" id="userAccountTopSettings" refs="userAccountTopSettings">
    <div v-if="showUserAccountDropdown" id="userAccountsDropdown" refs="userAccountsDropdown">
      <div class="user-account-title">{{$t('label.account', 1)}}</div>
      <el-select
        class="w-[175px]! float-left h-[34px]"
        ref="userAccountsSelect"
        :model-value="selectedAccountGroupId"
        :placeholder="currentAccountName"
        :teleported="false"
        @change="handleAccountDropdownChanged"
        @visible-change="handleAccountDropdownVisibleChanged">
        <template #header>
          <el-input
            ref="searchInputElement"
            v-model="searchInput"
            autofocus="true"
          >
          <template #prepend>
            <img width="14" src="@/static/icons/account_search_black.svg" />
          </template>
         </el-input>
        </template>
        <template #label>
          <span>{{ currentAccountName }}</span>
        </template>
        <el-option
          v-for="item in filteredAccountOptions"
          :key="item.groupId"
          :label="item.name"
          :value="item.groupId">
          <div class="base">
            <div class="text text-ellipsis overflow-hidden whitespace-nowrap text-[13px]" :title="item.name">{{ item.name }}</div>
          </div>
          <div class="cover"
          @mouseover="handleAccountNameHover($event, 'mouseover')" @mouseout="handleAccountNameHover($event, 'mouseout')">
          </div>
        </el-option>
      </el-select>
    </div>

    <!-- User Settings Button -->
    <router-link
      v-if="showSettingsButton"
      to="/settings"
      :custom="true"
      v-slot="{ navigate }"
    >
      <el-tooltip :popper-class="'custom-tooltip-popper'" :show-arrow="false" effect="light" class="item" :content="$t('label.settings')" placement="bottom">
        <div id="userSettingsIconTopSettings" @click="navigate" />
      </el-tooltip>
    </router-link>

    <!-- Active Plan -->
    <div v-if="userInfo && userInfo.activePlan.name === 'enterprise-demo'" id="activePlanLabel">
      <div class="name">{{$t('label.demoVersion')}}</div>
    </div>

    <!-- Upgrade -->
    <div id="upgradePlanBtn" v-if="showUpgradeButton">
      <router-link to="/plans" custom v-slot="{ navigate }">
        <el-button class="cstm-btn-gradient" @click="navigate">{{$t('planUpgrade.getPremium')}}</el-button>
      </router-link>
    </div>

  </div>
</template>

<script src="./user-account-top-settings.js"></script>
<style lang="scss" src="./user-account-top-settings.scss"></style>
